import { createStyles, CSSProperties, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import deepmerge from "deepmerge";
import * as React from "react";

import { PageSectionHeader } from ".";
import { RelodeTheme, ScrollContainer } from "../";

const baseStyles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
        },
        header: {
            flexGrow: 0,
        },
        content: {
            flexGrow: 1,
            display: "flex",
            backgroundColor: "transparent",
        },
        scrollContainer: {},
    });

const useStyles = makeStyles(
    (theme: RelodeTheme) => deepmerge(baseStyles(theme), theme.relode.controls.pageSection || {}),
    { name: "PageSection" }
);

type PageSectionCSSProperties = "root" | "header" | "content" | "scrollContainer";

export type PageSectionStyles = Partial<
    Record<PageSectionCSSProperties, CSSProperties | ((props?: {}) => CSSProperties)>
>;

interface Props {
    children?: React.ReactNode;
    className?: string;
    header?: React.ReactNode;
    sectionContentKey?: string;
    scrollbarType?: "none" | "perfect" | "normal";
}

export const PageSection = (props: Props) => {
    const { children, className: classNameProp, header, scrollbarType } = props;

    const classes = useStyles({});

    const rootClass = classnames(
        {
            [classes.root]: true,
        },
        classNameProp
    );

    return (
        <div className={rootClass}>
            {header && <PageSectionHeader>{header}</PageSectionHeader>}
            <div className={classes.content}>
                <ScrollContainer
                    className={classes.scrollContainer}
                    scrollContentKey={props.sectionContentKey}
                    scrollbarType={scrollbarType}
                >
                    {children}
                </ScrollContainer>
            </div>
        </div>
    );
};
